










import {Component, Vue} from 'vue-property-decorator';
import EditDialog from './PlywoodProductionProcessEditDialog.vue';
import CFlexGrid from '@/components/base/flex-grid/CFlexGrid.vue';
@Component({
    components: {CFlexGrid},
})
export default class PlywoodProductionProcess extends Vue {
    private editDialog = EditDialog;
}
